// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Several_container__kRBOp {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.Several_body__PIf06 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 95%;
}

.Several_tables__d1ZAb {
  margin-top: -25px;
  width: 100%;
  height: 80%;
  padding: 40px;
}

.Several_agencyTitle__3BXDa {
  font-size: 1.5rem;
  margin-top: 10330px;
  text-transform: uppercase;
}

.Several_maximoButton__Cjd\\+h {
  background-color: #365902;
  color: white;
  border: none;
  padding: 6px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.Several_maximoButton__Cjd\\+h:hover {
  background-color: #2d4a01; 
}


.Several_titleAgencias__L0Jrb {
  animation: Several_init__kwBPo 0.5s both;
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-left: 45px;
}

.Several_titleAgencias__L0Jrb,
.Several_title__8Qq\\+E {
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

@keyframes Several_init__kwBPo {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes Several_init2__nebYQ {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Several/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,wCAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n}\n\n.body {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 95%;\n}\n\n.tables {\n  margin-top: -25px;\n  width: 100%;\n  height: 80%;\n  padding: 40px;\n}\n\n.agencyTitle {\n  font-size: 1.5rem;\n  margin-top: 10330px;\n  text-transform: uppercase;\n}\n\n.maximoButton {\n  background-color: #365902;\n  color: white;\n  border: none;\n  padding: 6px 16px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.maximoButton:hover {\n  background-color: #2d4a01; \n}\n\n\n.titleAgencias {\n  animation: init 0.5s both;\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n  margin-left: 45px;\n}\n\n.titleAgencias,\n.title {\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Several_container__kRBOp`,
	"body": `Several_body__PIf06`,
	"tables": `Several_tables__d1ZAb`,
	"agencyTitle": `Several_agencyTitle__3BXDa`,
	"maximoButton": `Several_maximoButton__Cjd+h`,
	"titleAgencias": `Several_titleAgencias__L0Jrb`,
	"init": `Several_init__kwBPo`,
	"title": `Several_title__8Qq+E`,
	"init2": `Several_init2__nebYQ`
};
export default ___CSS_LOADER_EXPORT___;
